"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GalBaseDTO = void 0;
const class_transformer_1 = require("class-transformer");
const gal_events_1 = require("./gal-events");
const class_validator_1 = require("class-validator");
const decorators_1 = require("../decorators");
const conversion_type_1 = require("../decorators/conversion-type");
const gal_reporting_groups_1 = require("./gal-reporting-groups");
const extractValidationMessages = (errors) => {
    return errors.reduce((acc, error) => {
        var _a, _b;
        Object.entries((_a = error.constraints) !== null && _a !== void 0 ? _a : {}).forEach(([_, v]) => acc.push(v));
        if ((_b = error.children) === null || _b === void 0 ? void 0 : _b.length) {
            acc.push(...extractValidationMessages(error.children));
        }
        return acc;
    }, []);
};
class GalBaseDTO {
    constructor() {
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: gal_events_1.GalEvents[this.constructor.name]
        });
        Object.defineProperty(this, "extra", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    static toInstance(json, allowUndefined = false) {
        return (0, class_transformer_1.plainToInstance)(this, json, {
            enableImplicitConversion: false,
            exposeUnsetFields: allowUndefined,
        });
    }
    static toPlain(instance) {
        return (0, class_transformer_1.instanceToPlain)(instance, {
            exposeUnsetFields: false,
        });
    }
    static async validate(instance) {
        let errors = [];
        if (!instance) {
            return {
                valid: false,
                errors: ['* is undefined'],
            };
        }
        if (!instance.type || !gal_events_1.GalEvents[instance.type]) {
            errors.push('Property type must be a member of GalEvents Enum');
        }
        const validationCheck = instance instanceof GalBaseDTO
            ? instance
            : this.toInstance(instance, false);
        const validationErrors = await (0, class_validator_1.validate)(validationCheck, {
            skipMissingProperties: false,
            skipUndefinedProperties: false,
            skipNullProperties: false,
            forbidUnknownValues: true,
            whitelist: true,
            forbidNonWhitelisted: true,
            validationError: {
                target: true,
                value: true,
            },
        });
        errors = [
            ...errors,
            ...extractValidationMessages(validationErrors !== null && validationErrors !== void 0 ? validationErrors : []),
        ];
        return {
            valid: !errors.length,
            errors,
        };
    }
}
__decorate([
    (0, conversion_type_1.ConversionType)(conversion_type_1.CONVERSION_TYPE.snake_case_sans_dto),
    (0, decorators_1.Describe)('String of enum type GalEvents'),
    (0, class_validator_1.IsEnum)(gal_events_1.GalEvents),
    __metadata("design:type", Object)
], GalBaseDTO.prototype, "type", void 0);
__decorate([
    (0, class_validator_1.IsObject)(),
    (0, class_validator_1.IsOptional)(),
    (0, decorators_1.Describe)('Extra metadata if needed.'),
    (0, decorators_1.Warning)('Hard Limit of 2048 Bytes'),
    __metadata("design:type", Object)
], GalBaseDTO.prototype, "extra", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    (0, class_validator_1.IsEnum)(gal_reporting_groups_1.GalReportingGroups, { each: true }),
    __metadata("design:type", Function)
], GalBaseDTO, "allowedGroups", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Boolean]),
    __metadata("design:returntype", void 0)
], GalBaseDTO, "toInstance", null);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a = typeof T !== "undefined" && T) === "function" ? _a : Object]),
    __metadata("design:returntype", void 0)
], GalBaseDTO, "toPlain", null);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof T !== "undefined" && T) === "function" ? _b : Object]),
    __metadata("design:returntype", Promise)
], GalBaseDTO, "validate", null);
exports.GalBaseDTO = GalBaseDTO;
